module.exports = __webpack_public_path__ + "img/user-05.d2e52538.jpg";